import { action } from '@reatom/framework'

import { WeakRegistry } from '@blade/std-lib'
import { pairRegistry } from '@root/entities/pair/atoms'
import { userOrderEvent } from '@root/entities/realtime'

import { LimitOrderId } from '../model/limit-order-id'

import { reatomLimitOrder } from './reatom-limit-order'
import { limitOrderDtoReceivedEvent } from './reatom-limit-order-base'

import type { LimitOrderModel } from './reatom-limit-order'
import type { TradeApi } from '@root/shared/api'

export class LimitOrderRegistry {
  private registry = new WeakRegistry<string, LimitOrderModel>()

  public constructor() {
    userOrderEvent.onCall((ctx, update) => {
      const order = update.order
      if (!('trigger' in order)) {
        return
      }
      const orderModel = this.get(LimitOrderId(order.id))
      if (orderModel) {
        orderModel.updateFromDto(ctx, order)
      }
    })

    limitOrderDtoReceivedEvent.onCall((ctx, dto) => {
      const orderModel = this.get(LimitOrderId(dto.id))
      if (orderModel) {
        orderModel.updateFromDto(ctx, dto)
      }
    })
  }

  public get = (id: LimitOrderId) => {
    return this.registry.get(id)
  }
  public getOrCreate = (id: LimitOrderId, factory: () => LimitOrderModel) => {
    return this.registry.getOrCreate(id, factory)
  }
  public resolve = action((ctx, dto: TradeApi.LimitOrderDto) => {
    const pair = pairRegistry.resolveFromDto(ctx, dto.pairMeta)
    return this.getOrCreate(LimitOrderId(dto.id), () =>
      reatomLimitOrder({ dto, pair }),
    )
  })
  public set = (limitOrder: LimitOrderModel) => {
    this.registry.set(limitOrder.id, limitOrder)
  }
}

export const limitOrderRegistry = new LimitOrderRegistry()
